import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'saveModal', 'saveForm', 'saveName', 'saveTraits',
    'copyModal', 'copyForm'
  ];

  openSave(event) {
    event.preventDefault();
    event.stopPropagation();
    const t = event.currentTarget;
    const sampleId = t.dataset.sampleId;
    const sampleName = t.dataset.sampleName || '';
    const actionUrl = t.dataset.saveUrl;
    const traits = JSON.parse(t.dataset.traits || '[]');

    this.saveFormTarget.action = actionUrl;
    this.saveNameTarget.value = sampleName;

    this.saveTraitsTarget.innerHTML = '';
    if (traits.length === 0) {
      this.saveTraitsTarget.innerHTML = '<p class="text-sm text-gray-400 italic">This sample has no traits.</p>';
    } else {
      traits.forEach((tr) => {
        const label = document.createElement('label');
        label.className = 'flex items-center text-sm text-gray-700';
        label.innerHTML =
          `<input type="checkbox" name="trait_ids[]" value="${tr.id}" class="form-checkbox rounded mr-2" checked>` +
          `<span>${this._esc(tr.name)}</span>` +
          (tr.type ? `<span class="text-gray-400 ml-2">(${this._esc(tr.type)})</span>` : '');
        this.saveTraitsTarget.appendChild(label);
      });
    }

    this.saveModalTarget.classList.remove('hidden');
  }

  closeSave(event) {
    if (event) event.preventDefault();
    this.saveModalTarget.classList.add('hidden');
  }

  openCopy(event) {
    event.preventDefault();
    event.stopPropagation();
    const t = event.currentTarget;
    const actionUrl = t.dataset.copyUrl;
    this.copyFormTarget.action = actionUrl;
    this.copyModalTarget.classList.remove('hidden');
  }

  closeCopy(event) {
    if (event) event.preventDefault();
    this.copyModalTarget.classList.add('hidden');
  }

  _esc(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    })[c]);
  }
}
